import { Directive, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { OrderingOption } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { Register } from 'src/app/common-components/register/models/register';
import { getBannedAllowedIPsPrivilege } from 'src/app/privileges/privileges.selector';
import { AllowedIpFilterOptions } from './models/allowed-ip-filter-option';
import { AllowedIpPrivileges } from './models/allowed-ip-privileges';
import { AllowedIpRegisterOptions } from './models/allowed-ip-register-options';
import { AllowedIpRegisterListItem } from './models/allowed-ip-register-results.model';
import {
   allowedIpRegisterAdapterActions,
   allowedIpRegisterInitialFilter,
   createAllowedIp,
} from './state/allowed-ip-register.actions';
import * as allowedIpRegisterReducer from './state/allowed-ip-register.reducer';

@Directive()
export class AllowedIpRegister
   extends Register<AllowedIpRegisterListItem, AllowedIpRegisterOptions, OrderingOption>
   implements OnInit
{
   columns: string[];

   filters: AllowedIpFilterOptions[];

   entityName = 'Allowed IP';

   allowedIpPrivileges$: Observable<AllowedIpPrivileges>;

   constructor(public store: Store) {
      super(store, allowedIpRegisterReducer.selectors, allowedIpRegisterAdapterActions);
      this.allowedIpPrivileges$ = store.pipe(select(getBannedAllowedIPsPrivilege));
   }

   ngOnInit(): void {
      this.store.dispatch(allowedIpRegisterInitialFilter({ filters: this.filters }));
      this.store.dispatch(this.actions.pageEnter());
   }

   onCreate(): void {
      this.store.dispatch(createAllowedIp());
   }
}
